<template>
    <div>
        <h1 style="font-size: 24px; color: black;">游戏矩阵模板配置 </h1>
        <div style="margin-bottom: 10px;">
            <el-row>
                <el-button class="sub-sub" type="primary" @click="searchModelConfigBase">刷新</el-button>
                <el-button class="sub-sub" type="primary" @click="handleEdit('新增模板配置')">新增模板配置</el-button>
                <el-button   class="sub-sub" type="primary" @click="exportExcel">导出模板</el-button>
                <el-upload style="display:inline; margin-left:10px"   :action="upload()" :headers="headers"
                                           :on-success="handleSuccess"
                                           :before-upload="beforeUpload"
                                           :show-file-list="false"
                                           v-loading.fullscreen.lock="loading"  
                                           ref="upload">
                         <el-button  class="sub-sub"  type="primary"  >批量更新模板</el-button>
                </el-upload>
            </el-row>
        </div>
        <div>
            <el-table
                border
                :fit="true"
                :row-class-name="tableRowClass"
                :data="rules">
                <el-table-column prop="id" label="模板id"></el-table-column>
                <el-table-column prop="name" label="模板名称"></el-table-column>
                <el-table-column prop="count" label="选品数量"></el-table-column>
                <el-table-column label="操作" align="center" width="300px">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit('编辑游戏匹配',scope.row)">编辑</el-button>
                        <el-button size="mini" type="success" @click="showSelectorDialog(scope.row)">选品</el-button>
                        <el-button size="mini" type="info" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination
                @size-change="handleTotalSizeChange"
                @current-change="handleTotalCurrentChange"
                :current-page="queryData.page"
                :page-sizes="[30,50,70,100]"
                :page-size="queryData.size"
                layout="total, sizes, prev, pager, next"
                :total="totalSize">
            </el-pagination>
        </div>
        <div>
            <el-dialog :title="editDialogTitle"
                       center
                       :visible.sync="editDialogVisible"
                       @close="editDialogVisible=false"
                       width="600px">
                <el-form :model="modelConfigBaseForm">
                    <el-form-item label="模板名称" :label-width="labelWidth">
                        <el-input v-model="modelConfigBaseForm.name"></el-input>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmEditFormDialog">确 定</el-button>
                        <el-button type="info" @click="editDialogVisible=false">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </div>
        <div>
            <el-dialog title="选品管理"
                       center
                       :visible.sync="selectorDialogVisible"
                       @open="matchInfo"
                       @close="selectorDialogVisible=false"
                       :close-on-click-modal="false"
                       :show-close="false"
                       :destroy-on-close="true"
                       width="1500px">
                <h4>当前模板名称:<font size="6" bold>{{ this.rule.name }}</font></h4>
                <div style="margin-bottom: 10px;">
                    <span>游戏名称：</span>
                    <el-select v-model="queryGameSelector.name"  clearable  filterable placeholder="请选择/输入">
                        <el-option
                            v-for="item in gameSelectorList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                    <!-- 默认查询业务为208 -->
                    <span >业务类型：</span>
                    <el-select v-model="queryGameSelector.dept" clearable  placeholder="请选择/输入">
                                <el-option
                                        v-for="item in deptConst"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.value">
                                </el-option>
                    </el-select>
                    <span > 游戏标签：</span>
                    <el-cascader v-model="queryGameSelector.gameLabels" :options="labelList" :props="{ key:'id',value:'id', label:'name',multiple:true }" clearable collapse-tags></el-cascader>
                    <br>
                    <el-button type="primary" @click="queryGameList">查询</el-button>
                    <table>
                        <tr>
                            <td>
                                <el-button  type="primary" @click="clearAllSelected">一键清除</el-button>
                            </td>
                        </tr>
                    </table>
                </div>
                <template>
                    <h4>选择游戏</h4>
                    <el-table border
                              ref="multipleTable"
                              :data="gameList"
                              :row-class-name="gameRowTableClass"
                              stripe
                              tooltip-effect="dark"
                              style="width: 100%"
                              :row-key="getRowKeys"
                              @selection-change="handleSelectionChange"
                    >
                        <el-table-column
                            type="selection"
                            :reserve-selection="true"
                            width="55">
                        </el-table-column>
                        <el-table-column
                            type="index"
                            label="编号"
                            width="50">
                        </el-table-column>
                        <el-table-column
                            label="游戏类型" align="center">
                            <el-table-column
                                prop="name"
                                label="游戏名称">
                            </el-table-column>
                            <el-table-column
                                    prop="dept"
                                    label="业务类型">
                            </el-table-column>
                            <el-table-column
                                    :formatter="formatGameLabels"
                                    :show-overflow-tooltip="true"
                                    prop="gameLabelNames"
                                    label="游戏标签">
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                            prop="squareIcon"
                            label="大图标"
                            align="center">
                            <template slot-scope="scope">
                                <el-tag type="success" v-if="scope.row.squareIcon && scope.row.squareIcon !=''">有
                                </el-tag>
                                <el-tag type="info" v-else>无</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="bannerIcon"
                            :column-key=" 'bannerFlag' "
                            label="banner"
                            align="center">
                            <template slot-scope="scope">
                                <el-tag type="success" v-if="scope.row.bannerIcon && scope.row.bannerIcon !=''">有
                                </el-tag>
                                <el-tag type="info" v-else>无</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="microVideo"
                            :column-key=" 'videoFlag' "
                            label="视频"
                            align="center">
                            <template slot-scope="scope">
                                <el-tag type="success" v-if="scope.row.microVideo && scope.row.microVideo !=''">有
                                </el-tag>
                                <el-tag type="info" v-else>无</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="新品" align="center">
                            <el-table-column sortable="custom" prop="dtCreate" :formatter="formatDate" label="游戏发布时间">
                            </el-table-column>
                            <el-table-column sortable="custom" prop="dtUpdate" :formatter="formatDate" label="游戏更新时间">
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                    <div>
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="queryGameSelector.page"
                            :page-sizes="[5, 10,30,50,70,100]"
                            :page-size="queryGameSelector.size"
                            layout="total, sizes, prev, pager, next"
                            :total="totalElements">
                        </el-pagination>
                    </div>
                </template>
                <template v-if="selectedGameList.length>0">
                    <h4>已经选择的游戏</h4>
                    <el-table border
                              :data="selectedGameList"
                              tooltip-effect="dark"
                              style="width: 100%">
                        <el-table-column
                            type="index"
                            label="编号"
                            width="50">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="游戏名称">
                        </el-table-column>
                        <el-table-column
                                    :formatter="formatGameLabels"
                                    :show-overflow-tooltip="true"
                                    prop="gameLabelNames"
                                    label="游戏标签">
                            </el-table-column>
                        <el-table-column label="标签" align="center">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.label" placeholder="请选择">
                                    <el-option  
                                        v-for="item in labels"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="特效" align="center" width="150px">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.highLight" 
                                           :active-value="1"
                                           :inactive-value="0"
                                           active-text="有"
                                           inactive-text="无"
                                >
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column label="排序" align="center">
                            <template slot-scope="scope">
                                <el-input-number size="mini" v-model="scope.row.rank" ></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger"
                                           @click.native.prevent="deleteRow(scope.$index, scope.row)">移除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <el-form>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmAddSelect(selectedGameList,matchInfo())">确
                            定
                        </el-button>
                        <el-button type="info" @click="closeSelectorFormDialog()">返 回</el-button>
                    </div>
                </el-form>
            </el-dialog>

        </div>
    </div>
</template>

<script>
import {
      searchModelConfig,addModelConfig,updateModelConfig,deleteModelConfig,searchSelectedModelGames,searchGames,gameRunningList,allLabels,downloadData,allGameLabels
} from "@/http/api";
import utils from '@/utils'

export default {
    name: "ModelConfig",
    data() {
        return {
            headers: {},
            loading: false,
            VUE_APP_BASE_URL:null,
            checkAll: false,
            isIndeterminate: true,
            labelWidth: '100px',
            editDialogVisible: false,
            selectorDialogVisible: false,
            editDialogTitle: '',
            //模块编辑的数据对象
            modelConfigBaseForm: {
                "id": "",
                "name": ""
            },
            //版块列表数据
            rules: [], 
            //游戏列表
            gameList: [],
            //每行板块
            rule: {},
            //最终选中的列表
            selectedGameList: [],
            //临时新增展示的列表
            tempSelectedGameList: [],
            //判断是否进行监听selectedGameList 标志位
            flag: false,
            queryGameData: {
                name: '',
            },
            subQueryData: {},
            //设置当前页面总数
            totalSize: 0,
            queryData: {
                size: 30,
                page: 1
            },
            games: [],
            //LinkedIds:new Set(),
            labels: [],
            //游戏选品中游戏列表下拉框数据 固定的
            gameSelectorList: [],
            // 游戏选品
            queryGameSelector: {
                "name": '',
                "gameLabels": [],
                "gameLabelIds": [],
                "page": 1,
                "size": 10,
                "dept":''
            },
            //游戏选品总数
            totalElements: 0,
            pickerMinDate: '',
            // 业务组常量 目前写死 
            deptConst:[{id:0,name:'全部',value:null},
                {id:1,name:'208',value:"208"},
                {id:2,name:'211',value:"211"}],
            labelList:[],
        }
    },
    methods: {

        formatterPercent: function (row, column, cellValue) {
            return cellValue + "%";
        },
        formatGameLabels: function(row, column, cellValue) {
                var name="无";
                if(cellValue!=null && cellValue.length>0){
                   return  cellValue  ;
                } 
                return name;
            },
        handleEdit: function (title, row) {
            this.modelConfigBaseForm = {
                "id": "",
                "name": ""
            };

            this.editDialogTitle = title;
            this.editDialogVisible = true;

            if (row) {
                this.modelConfigBaseForm = {
                    "id": row.id,
                    "name": row.name
                };
            }
        },
        handleDelete: function (row) {
            this.$confirm('确认是否删除?', '警告', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteModelConfig(row.id).then(resp => {
                    if (resp.data.status === 0) {
                        this.searchModelConfigBase();
                    }
                })
            }).catch(() => {
            })
        },
        gameRowTableClass({row, rowIndex}) {
            row.index = rowIndex
        },
        getRowKeys(row) {
            return row.id
        },
        matchInfo: function () {
            return this.rule;
        },
        searchModelConfigBase: function () {
            searchModelConfig(this.queryData).then(resp => {
                this.rules = resp.data.info.content;
                //设置总条数
                this.totalSize = resp.data.info.totalElements;
            })
            this.headers = {Authorization: this.$store.state.user.token};
        },
        showSelectorDialog: function (row) {
            this.selectorDialogVisible = true;
            this.rule = row;
            this.queryGameSelector = {
                "name": '',
                "gameLabelIds": [],
                "gameLabels": [],
                "page": 1,
                "size": 10,
                "dept":"208"
            },
                //展示前清空临时已选游戏列表
                this.tempSelectedGameList = [];
            this.selectedGameList = [];
            //=========================================================初始化已选游戏列表
            //获取已选择的游戏信息 传入
            //console.log(this.rule.id);
            searchSelectedModelGames(this.rule.id).then(resp => {
                //设置临时已经选择的list
                if (resp.data.info) {
                    resp.data.info.forEach((info) => {
                        //设置额外字段   这里不能替换id因为判断是否已经选中复选框需要使用id作为gameId进行判断所以不能替换数据
                        let tempGameSelector=null;
                        tempGameSelector=info.game;
                        tempGameSelector.modelId=info.modelId;
                        tempGameSelector.gameId=info.gameId;
                        tempGameSelector.rank=info.rank;
                        tempGameSelector.label=info.label;
                        tempGameSelector.highLight=info.highLight;
                        // console.log(tempGameSelector)
                        //这里查询获取到的已经选择游戏
                        this.selectedGameList.push(info.game)
                    });
                }
                //调用通用数据处理方法
                this.gameSelectorTemp();
            });
        },
        confirmAddSelect(preList,row) {
            //console.log(preList)
            let _this = this;
            let gameSelectors = [];
            let obj = {};
            //构造新的游戏选品list 传给后台
            gameSelectors= preList.reduce((cur, next) => {
                        obj[next.id] ? "" : (obj[next.id] = true && cur.push(
                            {
                                modelId: row.id,
                                gameId: next.id,
                                rank: next.rank,
                                label: next.label,
                                highLight: next.highLight
                                }));
                        return cur;
                    }, []);             
            //  ========这里设置games为游戏选品list
            _this.rule.games=gameSelectors;
            // console.log(_this.rule);
            //这里 改成传入  在后台进行已有数据清空
            updateModelConfig(_this.rule).then(resp => {
                if (resp.data.status === 0) {
                    _this.searchModelConfigBase();
                }
            }).catch(function () {
            });
            //调用关闭dialog接口
            this.closeSelectorFormDialog();
        },
        deleteRow(index, row) {
            this.selectedGameList.splice(index, 1);
            this.gameList.forEach(item => {
                if (item.id === row.id) {
                    this.$refs.multipleTable.toggleRowSelection(item, false);
                    this.tempSelectedGameList.forEach((game, index) => {
                        //如果删除的是临时的游戏选品 而不是已经选好的 需要清除对应templist
                        if (game.id === row.id) this.tempSelectedGameList.splice(index, 1)
                    })
                }
            })
        },

        tableRowClass: function (row) {
            if (row.rowIndex % 2 === 1) {
                return 'row_odd_class'
            }
            return ''
        },
        confirmEditFormDialog: function () {
            let _message = '';
            if (this.modelConfigBaseForm.name === '') {
                _message = '请输入模板名称'
            }
            if (_message) {
                this.$message({
                    message: _message,
                    type: 'error'
                });
                return;
            }
            // console.log("编辑/新增模板配置时id为:{}",this.modelConfigBaseForm.id)
            // console.log(this.modelConfigBaseForm.id)
            if (this.modelConfigBaseForm.id === "") {
                addModelConfig(this.modelConfigBaseForm).then(resp => {
                    if (resp.data.status === 0) {
                        this.editDialogVisible = false;
                        this.searchModelConfigBase();
                    }
                });
            } else {
                updateModelConfig(this.modelConfigBaseForm).then(resp => {
                    if (resp.data.status === 0) {
                        this.editDialogVisible = false;
                        this.searchModelConfigBase();
                    }
                });
            }

        },
        handleSelectionChange(val) {
            let _this = this;
            //console.log('select', val)
            val.forEach(function (game) {
                //设置默认值
                _this.$set(game, 'rank', 0);
                _this.$set(game, 'label', 0);
                _this.$set(game, 'highLight', 0);
                _this.selectedGameList.forEach(function (gameSelector) {
                    if (game.id === gameSelector.id) {
                        _this.$set(game, 'rank', gameSelector.rank);
                        _this.$set(game, 'label', gameSelector.label)
                        _this.$set(game, 'highLight', gameSelector.highLight)
                    }
                })
            });
            _this.tempSelectedGameList = val
        },
        gameSelectorTemp() {
            //这个flag是设置watch监听事件 当跟新完当前页已选游戏标志位后再下一次渲染中设置为true
            this.flag = false
            //重要 这里是element分页的一个bug 在分页情况下切换已勾选页会重复添加已勾选数据 所以在这里清除全部勾选
            ;this.gameList.forEach(item => {
                this.$refs.multipleTable.toggleRowSelection(item, false);
            });
            let newLabelIds =[];// eslint-disable-line no-unused-vars
                 this.queryGameSelector.gameLabels.forEach(function (category) {
                      category.forEach(function (sub,index) {
                         if(index%2!==0){
                             newLabelIds.push(sub);
                         }
                      })
                 });
                 this.queryGameSelector.gameLabelIds=newLabelIds;
            searchGames(this.queryGameSelector).then( resp => {
                this.gameList = resp.data.info.content;
                this.totalElements = resp.data.info.totalElements;
                //获取已选中游戏id
                const ids = [];
                this.selectedGameList.length && this.selectedGameList.forEach(item => {
                    ids.push(item.id)
                });
                //临时temp数组
                const tempSelectedGameList = [];
                //console.log('xxxx', ids)
                //判断当前页是否有已选中游戏 如果有设置已勾选
                ids.length && this.gameList.forEach(item => {
                    if (ids.indexOf(item.id) > -1) {
                        tempSelectedGameList.push(item);
                        this.$refs.multipleTable.toggleRowSelection(item, true);
                    }
                });
                //console.log('new page: ', tempSelectedGameList)
                //赋值
                this.tempSelectedGameList = tempSelectedGameList;
                //渲染 并设置flag为true
                this.$nextTick(() => this.flag = true)
            });
        },
        closeSelectorFormDialog: function () {
            this.selectedGameList = [];
            this.tempSelectedGameList = [];
            this.selectorDialogVisible = false;
        },
        handleSizeChange(newSize) {
            this.queryGameSelector.size = newSize;
            this.gameSelectorTemp()
        },
        handleCurrentChange(newPage) {
            this.queryGameSelector.page = newPage;
            this.gameSelectorTemp()
        },
        // 总条数修改
        handleTotalSizeChange(newSize) {
            this.queryData.size = newSize;
            this.searchModelConfigBase();
        },
        //总页数跳转
        handleTotalCurrentChange(newPage) {
            this.queryData.page = newPage;
            this.searchModelConfigBase();
        },
        formatDate: function (row, column) {
            return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD HH:mm:ss")
        },
        queryGameList() {
            //todo  判断排序 页数置1
            this.queryGameSelector.page = 1;
            this.gameSelectorTemp()
        },
        clearAllSelected() {
            //清除全部已选游戏
            //这个flag是设置watch监听事件 当跟新完当前页已选游戏标志位后再下一次渲染中设置为true
            // this.flag = false
            //重要 这里是element分页的一个bug 在分页情况下切换已勾选页会重复添加已勾选数据 所以在这里清除全部勾选
            // this.gameList.forEach(item => {
            //     this.$refs.multipleTable.toggleRowSelection(item,false);
            // })
            this.$refs.multipleTable.clearSelection();
            this.selectedGameList = [];
            this.tempSelectedGameList = [];
            // this.flag=true;
        },
        handleSuccess(data){
            //查询数据
            this.searchModelConfigBase();
            this.headers = {Authorization: this.$store.state.user.token};
            if(data.status==0){
                this.$message({
                    message: "更新成功",
                    type: 'success'
                });
            }else{
                this.$message({
                        message: "更新失败",
                        type: 'error'
                    });
            }
        },
        beforeUpload(data){
            console.log(data);
        },
        upload() {
            //todo
            return this.VUE_APP_BASE_URL + 'model/importExcel';
        },
        exportExcel() {
                let fileName = new Date().toLocaleString() + '_模板配置.xlsx';
                downloadData(
                    '/model/exportExcel',
                    null,
                    fileName
                )
            },
    },
    mounted() {
        this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
    },
    watch: {

        tempSelectedGameList: {
            handler(val, oldVal) {
                //console.log('tempSelectedGameList', val, oldVal)
                //如果是加载数据阶段设置勾选时 不进行监听直接返回
                if (!this.flag) return;
                //新增数据判断
                const isAdd = val.length > oldVal.length;
                const oldArr = [], arr = [];
                oldVal.forEach((item) => {
                    oldArr.push(item.id)
                });
                val.forEach((item) => {
                    arr.push(item.id)
                });
                //console.log('arr', oldArr, arr)
                if (isAdd) {
                    let result = [];
                    arr.forEach(id => {
                        //把新增的数据项push进结果中 result
                        if (oldArr.indexOf(id) === -1) {
                            result.push(id)
                        }
                    });
                    result.forEach(id => {
                        //新数据中如果 id为新增数据项已经初始化之后了ranklabel 则添加到selectedGameList最终结果中
                        val.forEach((item) => {
                            if (item.id === id) this.selectedGameList.push(item)
                        })
                    })
                } else {
                    //删除时
                    let result = [];
                    oldArr.forEach(id => {
                        //把删除的id找出来
                        if (arr.indexOf(id) === -1) {
                            result.push(id)
                        }
                    });
                    //把selectedGameList中对应resultId 删除
                    result.forEach(id => {
                        this.selectedGameList.forEach((item, index) => {
                            if (item.id === id) this.selectedGameList.splice(index, 1)
                        })
                    })
                }
            }
        },
    },
    created() {
        allLabels().then(resp => {
            this.labels = resp.data.info;
        });
        gameRunningList().then(resp => {
            this.gameSelectorList = resp.data.info;
        });
        this.searchModelConfigBase();
        // 获取游戏标签
            allGameLabels().then(resp=>{
                this.labelList=resp.data.info;
            })
    },
}
</script>

<style lang="less">
.sub-sub7 {
    position: relative;
    left: 600px
}
</style>
